import { useTranslation } from 'react-i18next'

import * as SvgIcons from 'assets/svg/sprite'
import { Button } from 'components/Button/Button'
import { useShareStory } from 'services/stories'
import { type NewStory } from 'types/api/story'

interface ShareStoryProps {
  story: NewStory
  onSuccess?: () => void
  disabled?: boolean
}

export const ShareStory = ({ story, onSuccess, disabled = false }: ShareStoryProps) => {
  const { t } = useTranslation()
  const { handleShareClick, isSubmitting } = useShareStory({ story, onSuccess })

  return (
    <Button
      text={t('share')}
      color="blue"
      padding="5"
      width="fit"
      height="5"
      font="mont-14-normal"
      prevIcon={<SvgIcons.IconPlusInCircleDashed />}
      clickFn={handleShareClick}
      disabled={disabled || isSubmitting}
    />
  )
}